import { render, staticRenderFns } from "./CustomerGaugeChart.vue?vue&type=template&id=51ada820&"
import script from "./CustomerGaugeChart.vue?vue&type=script&lang=js&"
export * from "./CustomerGaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports